export const Table_Colors = {
  primary: '#1976d2',
  primaryLight: '#42a5f5',
  background: '#f8fafc',
  tableHeader: '#f5f5f5',
  border: '#e0e0e059',

  text: {
    primary: '#1e293b',
    secondary: '#64748b',
  },
};

export default Table_Colors;